// extracted by mini-css-extract-plugin
export var titleOverflow = "heroBlock-module--titleOverflow--+7Ae4";
export var body = "heroBlock-module--body--uxjj6";
export var buttonsContainer = "heroBlock-module--buttonsContainer--3uHj9";
export var button = "heroBlock-module--button---ha6q";
export var fade = "heroBlock-module--fade--zD-T4";